import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const orderAdditionalCostTypesAdapter = getAdapter({ idFieldName: 'value' });

const orderAdditionalCostTypesSlice = createSlice({
    name: 'orderAdditionalCostTypes',
    initialState: orderAdditionalCostTypesAdapter.getInitialState(),
    reducers: {
        setOrderAdditionalCostTypes: (state, { payload: { orderAdditionalCostTypes } }) => {
            orderAdditionalCostTypesAdapter.setAll(state, orderAdditionalCostTypes);
        },
    },
});

const selectors = orderAdditionalCostTypesAdapter.getSelectors(({ orderAdditionalCostTypes }) => orderAdditionalCostTypes);

export const getOrderAdditionalCostTypes = (state) => selectors.selectAll(state);

export const {
    setOrderAdditionalCostTypes,
} = orderAdditionalCostTypesSlice.actions;

export default orderAdditionalCostTypesSlice.reducer;
